import React from 'react';

import { OtherQualificationsForm } from '../../Form/Forms';

export default () => (
  <div className="form-content">
    <OtherQualificationsForm />
  </div>
);
